<h3>Step {{ currentStep }} of {{ totalSteps }}</h3>
